export const environment = {
  production: false,
  // stripeKey:
  //   'pk_test_51PYNoIJCIMoB8topmB8vcTutdd0hIk4htFutZOvbB3vWQ8NJ08dBwt8WXJQbhduuE6Nb939ZlrRGb1RwUPUIdzxn0070RHSpti',
  stripeKey: '',
  baseUrl: 'https://uw.dev.levelaccess.io/',
  apiUserWay: 'https://uw.dev.levelaccess.io/',
  intercomId: 'mi5ahsss',
  isNewApp: true,
  isFeatureBranchingMode: false,
  consoleUrl: 'https://manage.uw.dev.levelaccess.io/',
  googleTagManagerId: 'GTM-M88WJJ2',
  inspectorUrl: 'https://inspect.qa.userway.dev/',
  becomePartnerUrl: 'https://dev.userway.dev/reseller/',
  LALoginLink:
    'https://dashboard.dev.dev.levelaccess.io/login-organization-redirection?returnTo=external-userway-dashboard',
  amplitudeApiKey: '548e64f13953ab11a21ceeff8214c5fe',
  amplitudeApiServerUrl: 'https://amplitude.userway.dev/2/httpapi',
  // Temporary commented due to an error on the website
  // becomePartnerUrl: 'https://qa.userway.dev/reseller/?p=popup_reseller&email=',
};
